import { createSlice } from '@reduxjs/toolkit';

export const clientSlice = createSlice({
    name: "client",
    initialState: null,
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const clientActions = clientSlice.actions;

export default clientSlice.reducer;